import { render, staticRenderFns } from "./ConfigurationForm1110.vue?vue&type=template&id=28b831b9&scoped=true&lang=pug&"
import script from "./ConfigurationForm1110.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm1110.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm1110.vue?vue&type=style&index=0&id=28b831b9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b831b9",
  null
  
)

export default component.exports